import axios from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function storeTalk (pFormData) {
    const URI = `${BASE_URL}/api/talks`
    return axios.post(URI, pFormData, { headers })
}

function updateTalk (pFormData, pIdTalk) {
    const URI = `${BASE_URL}/api/talks/${pIdTalk}`
    return axios.post(URI, pFormData, { headers })
}

function destroyTalk (pIdTalk) {
    const URI = `${BASE_URL}/api/talks/${pIdTalk}`
    return axios.delete(URI, { headers })
}

export {
    storeTalk,
    updateTalk,
    destroyTalk
}